import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { fetchDashboardStats } from '../../slices/DashboardSlices.ts';
import { getAllClients } from '../../slices/ClientSlice.ts';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../utils/util.service.ts';
import { getAllAssignments } from '../../slices/AssignmentSlice.ts';
import { getAllRequest } from '../../slices/RequestSlice.tsx';
import StackedBarChart from '../../components/charts/StackedBarChart.tsx';


const Dashboard: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { dashboardStats, offset, limit } = useSelector((state: RootState) => state.dashboard);
    const { clients, offset: clientOffset, limit: clientLimit } = useSelector((state: RootState) => state.clientSlice);
    const { requests } = useSelector((state: RootState) => state.requestSlice);
    const { assignments } = useSelector((state: RootState) => state.assignmentSlice);
    const navigate = useNavigate();


    useEffect(() => {
        dispatch(fetchDashboardStats({
            offset: offset,
            limit: limit,
            sortField: "created_at",
            sortOrder: 1,
            searchInput: ""
        }));
        dispatch(getAllClients({
            offset: offset,
            limit: limit,
            sortField: "created_at",
            sortOrder: 1,
            searchInput: ""
        }));
        dispatch(getAllAssignments({
            offset: offset,
            limit: limit,
            sortField: "created_at",
            sortOrder: 1,
            searchInput: ""
        }));
        dispatch(getAllRequest({
            offset: offset,
            limit: limit,
            sortField: "created_at",
            sortOrder: 1,
            searchInput: ""
        }));
    }, [dispatch]);


    const totalRequests = assignments.length;
    const accepted = assignments.filter((r) => r.vendor_id !== null).length;
    const pending = assignments.filter((r) => r.vendor_id === null).length;
    const rejected = 0;

    const percent = (count: number) => ((count / totalRequests) * 100).toFixed(1);


    const requestStats = [
        { name: "Accepted", value: accepted },
        { name: "Pending", value: pending },
        { name: "Rejected", value: rejected }
    ];

    const chartColors = {
        "Accepted": "#10B981", 
        "Pending": "#F59E0B",
        "Rejected": "#EF4444"  
    };


    return (
        <div className="w-full">
            <div className="bg-[#EDF1F6] p-2 md:p-4 max-w-[1920px] mx-auto">
                <div className="flex flex-col md:flex-row justify-between mb-4">
                    <div className="text-lg font-medium">👋 Good Morning Johnny!</div>
                    <div className="text-lg font-semibold">Overview</div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

                    <div className="bg-white p-4 rounded-lg shadow">
                        <h1 className="text-sm text-gray-500">Total Requests</h1>
                        <h1 className="text-xl font-semibold">{dashboardStats[0]?.totalRequests}</h1>
                    </div>

                    <div className="bg-white p-4 rounded-lg shadow">
                        <h1 className="text-sm text-gray-500">Accepted</h1>
                        <h1 className="text-xl font-semibold">{accepted}</h1>
                    </div>

                    <div className="bg-white p-4 rounded-lg shadow">
                        <h1 className="text-sm text-gray-500">Pending</h1>
                        <h1 className="text-xl font-semibold">{pending}</h1>
                    </div>

                    <div className="bg-white p-4 rounded-lg shadow">
                        <h1 className="text-sm text-gray-500">Rejected</h1>
                        <h1 className="text-xl font-semibold">{rejected}</h1>
                    </div>

                    <div className="bg-white p-4 rounded-lg shadow">
                        <h1 className="text-sm text-gray-500">Total Customers</h1>
                        <h1 className="text-xl font-semibold">{dashboardStats[0]?.totalCustomers}</h1>
                    </div>

                    <div className="bg-white p-4 rounded-lg shadow">
                        <h1 className="text-sm text-gray-500">Total Vendors</h1>
                        <h1 className="text-xl font-semibold">{dashboardStats[0]?.totalVendors}</h1>
                    </div>
                </div>




                {/* <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-4">
                    <div className="bg-white p-4 rounded-lg shadow col-span-1 lg:col-span-2">
                        <div className="flex justify-between items-center mb-4">
                            <div className="flex space-x-2">
                                <h1>Overall Report</h1>
                                <button className="px-3 py-1 text-sm font-medium text-white bg-[#104E70] rounded-md">12 Months</button>
                                <button className="px-3 py-1 text-sm text-gray-600 border border-gray-300 rounded-md">6 Months</button>
                                <button className="px-3 py-1 text-sm text-gray-600 border border-gray-300 rounded-md">30 Days</button>
                                <button className="px-3 py-1 text-sm text-gray-600 border border-gray-300 rounded-md">7 Days</button>
                            </div>
                            <button className="flex items-center text-sm text-gray-600 border border-gray-300 px-3 py-1 rounded-md">
                                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                                </svg>
                                Export PDF
                            </button>
                        </div>

                        <div className="h-48 bg-gray-100 rounded-md flex items-center justify-center text-gray-400">
                            Chart Goes Here
                        </div>
                    </div>

                    <div className="bg-white p-4 rounded-lg shadow">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-sm font-semibold text-gray-700">Requests Report</h2>
                            <span className="text-xs text-gray-500">Last Month</span>
                        </div>

                        <div className="space-y-4 text-sm">
                            <div>
                                <div className="flex justify-between">
                                    <span>Total Requests</span>
                                    <span>{totalRequests}</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full">
                                    <div className="h-2 bg-[#4F46E5] rounded-full w-full"></div>
                                </div>
                            </div>

                            <div>
                                <div className="flex justify-between">
                                    <span>Pending</span>
                                    <span>{pending}</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full">
                                    <div
                                        className="h-2 bg-[#4F46E5] rounded-full"
                                        style={{ width: `${percent(pending)}%` }}
                                    ></div>
                                </div>
                            </div>

                            <div>
                                <div className="flex justify-between">
                                    <span>Accepted</span>
                                    <span>{accepted}</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full">
                                    <div
                                        className="h-2 bg-[#4F46E5] rounded-full"
                                        style={{ width: `${percent(accepted)}%` }}
                                    ></div>
                                </div>
                            </div>

                            <div>
                                <div className="flex justify-between">
                                    <span>Rejected</span>
                                    <span>{rejected}</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full">
                                    <div className="h-2 bg-[#4F46E5] rounded-full"
                                        style={{ width: `${percent(rejected)}%` }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className="mt-6 grid grid-cols-1 lg:grid-cols-5 gap-4">
                    <div className="bg-white p-4 rounded-lg shadow col-span-1 lg:col-span-3">
                        <div className="flex justify-between items-center px-2 mb-4">
                            <h2 className="text-lg font-semibold text-gray-700">Request Statistics</h2>
                        </div>
                        <div>
                            <StackedBarChart
                                height={200}
                                data={requestStats}
                                colors={chartColors}
                                titleStyle={{ fontSize: '16px', fontWeight: 600, color: '#374151' }}
                            />
                        </div>
                    </div>

                    <div className="bg-white p-4 rounded-lg shadow col-span-1 lg:col-span-2">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-sm font-semibold text-gray-700">Requests Report</h2>
                            <span className="text-xs text-gray-500">Last Month</span>
                        </div>

                        <div className="space-y-4 text-sm">
                            <div>
                                <div className="flex justify-between">
                                    <span>Total Requests</span>
                                    <span>{totalRequests}</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full">
                                    <div className="h-2 bg-[#4F46E5] rounded-full w-full"></div>
                                </div>
                            </div>

                            <div>
                                <div className="flex justify-between">
                                    <span>Pending</span>
                                    <span>{pending}</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full">
                                    <div
                                        className="h-2 bg-[#4F46E5] rounded-full"
                                        style={{ width: `${percent(pending)}%` }}
                                    ></div>
                                </div>
                            </div>

                            <div>
                                <div className="flex justify-between">
                                    <span>Accepted</span>
                                    <span>{accepted}</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full">
                                    <div
                                        className="h-2 bg-[#4F46E5] rounded-full"
                                        style={{ width: `${percent(accepted)}%` }}
                                    ></div>
                                </div>
                            </div>

                            <div>
                                <div className="flex justify-between">
                                    <span>Rejected</span>
                                    <span>{rejected}</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full">
                                    <div className="h-2 bg-[#4F46E5] rounded-full"
                                        style={{ width: `${percent(rejected)}%` }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-4">
                    <div className="bg-white p-4 rounded-lg shadow col-span-1 lg:col-span-2 max-h-[350px] overflow-y-auto">
                        <div className="flex justify-between items-center px-2 mb-4">
                            <h2 className="text-lg font-semibold text-gray-700">Recent Requests</h2>
                            <button onClick={() => navigate('/requests')} className="text-lg text-indigo-600 font-medium">See All Requests →</button>
                        </div>

                        <div className="space-y-4 text-sm">
                            {requests.map((item, index) => (
                                <div
                                    key={index}
                                    className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center border-b pb-6 last:border-none"
                                >
                                    <div className="flex items-center">
                                        <span className="ml-2 text-gray-700 font-medium">{item.name}</span>
                                    </div>
                                    <div className="text-gray-500 hidden md:block">{item.service_name}</div>
                                    <div className="text-gray-500 hidden md:block">{item.sub_service_name}</div>
                                    <div className="text-gray-500 text-sm">
                                        {new Date(item.created_at).toLocaleDateString()}
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>

                    <div className="bg-white p-4 rounded-lg shadow max-h-[350px] overflow-y-auto">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-sm font-semibold text-gray-700">Recent Clients</h2>
                        </div>
                        <div className="space-y-4">
                            {clients?.slice(0, 5).map((client, index) => (
                                <div key={index} className="flex items-center space-x-3">
                                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                                        <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 2a4 4 0 100 8 4 4 0 000-8zm-6 14a6 6 0 1112 0H4z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-sm font-medium text-gray-700">{capitalizeFirstLetter(client.name)}</p>
                                        <p className="text-xs text-gray-400">{client.email}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div onClick={() => navigate('/clients')} className="mt-4 text-indigo-600 text-sm font-medium cursor-pointer">
                            SEE ALL CLIENTS →
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Dashboard;